import { useState } from "react";

interface IState {
    loading: boolean,
    
}

const initialState = {
    loading: true, 
}

const useInitialState = () => {
    const [stateComercio,setStateComercio] = useState<IState>(initialState);
    const [loadingFetch, setLoadingFetch] = useState<boolean>(false)
   
    return{
        stateComercio,
        setStateComercio,
    }
}

export default useInitialState